/**
 * One-shot signal that a fresh interactive login just succeeded, scoped to the US FEB
 * credit-check consent POST (CASHDAP-3450).
 *
 * The consent POST must distinguish a fresh interactive login from a silent persistent-login
 * resume, but it cannot share flow/remember-me/loginSignal.ts wholesale: that signal's call sites
 * are deliberately curated for remember-me minting (see state/auth/user/actions.ts), and several
 * login completions that SHOULD count for consent — the SMS-verify flow, first-password creation,
 * and the verify challenge — are intentionally not remember-me mint sites. So
 * `markInteractiveLogin` piggybacks a mark here (every remember-me-eligible login also counts for
 * consent), and those additional completions mark this signal directly, without widening the
 * remember-me surface.
 *
 * Same module-state design rationale as loginSignal.ts / consentCopySignal.ts: never persisted,
 * set only at explicit login-success call sites gated on `postLoginRoute === Route.LOGGED_IN`,
 * so a reload simply drops the mark and consent capture defers to the next login. A plain
 * boolean rather than a generation counter because the consent POST is its only consumer.
 */
let interactiveLoginPending = false

export const markUsFebConsentInteractiveLogin = (): void => {
  interactiveLoginPending = true
}

export const consumeUsFebConsentInteractiveLogin = (): boolean => {
  const pending = interactiveLoginPending
  interactiveLoginPending = false
  return pending
}
